import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, Teleport as _Teleport, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-724bbafc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "traslados-container" };
const _hoisted_2 = {
    class: "header-top-controls m-0 w-full",
    style: { "display": "flex", "justify-content": "flex-end", "gap": "1rem", "width": "100%" }
};
const _hoisted_3 = {
    class: "search-container",
    style: { "flex": "1", "max-width": "300px", "margin-bottom": "0" }
};
const _hoisted_4 = { class: "search-wrapper m-0" };
const _hoisted_5 = { class: "filters-group-premium flex items-center gap-3" };
const _hoisted_6 = { class: "select-filter-premium" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "Todos los estados", -1 /* HOISTED */));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "PENDIENTE" }, "Pendientes", -1 /* HOISTED */));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "COMPLETADO" }, "Completados", -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "CANCELADO" }, "Cancelados", -1 /* HOISTED */));
const _hoisted_11 = [
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10
];
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Nuevo Traslado", -1 /* HOISTED */));
const _hoisted_13 = { class: "table-container shadow card" };
const _hoisted_14 = { class: "marcas-table" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Documento / Nro"),
        /*#__PURE__*/ _createElementVNode("th", null, "Origen"),
        /*#__PURE__*/ _createElementVNode("th", null, "Destino"),
        /*#__PURE__*/ _createElementVNode("th", null, "Fecha"),
        /*#__PURE__*/ _createElementVNode("th", null, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_16 = { key: 0 };
const _hoisted_17 = {
    colspan: "6",
    class: "text-center py-8"
};
const _hoisted_18 = { class: "loading-state" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-muted" }, "Cargando traslados...", -1 /* HOISTED */));
const _hoisted_20 = { key: 1 };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "6",
    class: "text-center py-4 text-muted"
}, "No se han encontrado movimientos con ese filtro.", -1 /* HOISTED */));
const _hoisted_22 = [
    _hoisted_21
];
const _hoisted_23 = {
    class: "attribute-badge",
    style: { "color": "#3b82f6" }
};
const _hoisted_24 = { class: "actions-column" };
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
    key: 0,
    class: "pagination-container mt-4 flex items-center justify-between"
};
const _hoisted_29 = { class: "text-sm text-slate-500" };
const _hoisted_30 = { class: "flex gap-2" };
const _hoisted_31 = ["disabled"];
const _hoisted_32 = ["disabled"];
const _hoisted_33 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_34 = {
    class: "modal-window",
    style: { "max-width": "800px", "width": "95%" }
};
const _hoisted_35 = { class: "modal-header header-dark-premium" };
const _hoisted_36 = { class: "modal-title-group" };
const _hoisted_37 = {
    class: "icon-bulb-premium",
    style: { "color": "#10b981", "border-color": "rgba(16, 185, 129, 0.2)" }
};
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "hero-text-content" }, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title-text text-white" }, "Registrar Traslado"),
    /*#__PURE__*/ _createElementVNode("span", { class: "rif-subtitle-text" }, "MOVIMIENTO LOGÍSTICO")
], -1 /* HOISTED */));
const _hoisted_39 = { class: "form-scroll-area" };
const _hoisted_40 = { class: "premium-form-card" };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-badge-premium" }, "Detalles del Movimiento", -1 /* HOISTED */));
const _hoisted_42 = { class: "grid-layout-premium" };
const _hoisted_43 = { class: "input-group-premium full-col" };
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("input", {
    type: "text",
    value: "Generado automáticamente al guardar",
    disabled: "",
    style: { "background": "#f8fafc", "color": "#94a3b8", "border": "2px dashed #cbd5e1", "font-style": "italic", "cursor": "not-allowed" }
}, null, -1 /* HOISTED */));
const _hoisted_45 = { class: "input-group-premium" };
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione Almacén de Origen...", -1 /* HOISTED */));
const _hoisted_47 = ["value"];
const _hoisted_48 = { class: "input-group-premium" };
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione Almacén de Destino...", -1 /* HOISTED */));
const _hoisted_50 = ["value", "disabled"];
const _hoisted_51 = { class: "input-group-premium full-col" };
const _hoisted_52 = { class: "premium-form-card mt-6" };
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "card-badge-premium",
    style: { "background": "#eef2ff", "color": "#6366f1" }
}, "Ítems del Traslado", -1 /* HOISTED */));
const _hoisted_54 = { class: "product-search-box mb-4" };
const _hoisted_55 = { class: "input-group-premium" };
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, " Buscar Producto para añadir ", -1 /* HOISTED */));
const _hoisted_57 = { style: { "position": "relative", "display": "flex", "align-items": "center" } };
const _hoisted_58 = ["disabled", "placeholder"];
const _hoisted_59 = {
    key: 0,
    class: "search-results-dropdown shadow-xl border border-slate-200"
};
const _hoisted_60 = ["onClick"];
const _hoisted_61 = { style: { "width": "40px", "height": "40px", "border-radius": "10px", "background-color": "#eef2ff", "border": "1px solid #e0e7ff", "display": "flex", "align-items": "center", "justify-content": "center", "flex-shrink": "0" } };
const _hoisted_62 = { style: { "flex": "1", "display": "flex", "flex-direction": "column", "gap": "4px" } };
const _hoisted_63 = { style: { "font-weight": "700", "color": "#1e293b", "font-size": "0.9rem", "line-height": "1.2" } };
const _hoisted_64 = { style: { "display": "flex", "align-items": "center", "gap": "8px" } };
const _hoisted_65 = { style: { "background-color": "#f1f5f9", "color": "#475569", "padding": "2px 6px", "border-radius": "4px", "font-size": "0.7rem", "font-weight": "600", "font-family": "monospace", "letter-spacing": "0.05em" } };
const _hoisted_66 = { style: { "display": "flex", "align-items": "center", "gap": "12px" } };
const _hoisted_67 = {
    style: { "width": "32px", "height": "32px", "border-radius": "50%", "background-color": "#f1f5f9", "display": "flex", "align-items": "center", "justify-content": "center", "color": "#64748b", "transition": "all 0.2s" },
    onmouseover: "this.style.backgroundColor='#6366f1'; this.style.color='white';",
    onmouseout: "this.style.backgroundColor='#f1f5f9'; this.style.color='#64748b';"
};
const _hoisted_68 = {
    class: "premium-form-card p-0 overflow-hidden",
    style: { "margin-top": "1rem", "border": "1px solid #e2e8f0" }
};
const _hoisted_69 = {
    class: "marcas-table",
    style: { "margin": "0" }
};
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { style: { "background": "#f8fafc", "border-bottom": "2px solid #e2e8f0", "font-size": "0.75rem" } }, "Repuesto (SKU)"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "background": "#f8fafc", "border-bottom": "2px solid #e2e8f0", "text-align": "center", "width": "100px", "font-size": "0.75rem" } }, " Stock Origen"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "background": "#f8fafc", "border-bottom": "2px solid #e2e8f0", "text-align": "center", "width": "120px", "font-size": "0.75rem" } }, " Cantidad"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "background": "#f8fafc", "border-bottom": "2px solid #e2e8f0", "text-align": "center", "width": "60px" } })
    ])
], -1 /* HOISTED */));
const _hoisted_71 = { style: { "padding": "1rem 1.5rem" } };
const _hoisted_72 = { style: { "font-weight": "700", "color": "#1e293b", "font-size": "0.95rem" } };
const _hoisted_73 = { style: { "font-size": "0.8rem", "color": "#64748b", "margin-top": "4px", "font-family": "monospace" } };
const _hoisted_74 = { style: { "padding": "1rem 0", "text-align": "center" } };
const _hoisted_75 = {
    class: "attribute-badge",
    style: { "background": "#e0e7ff", "color": "#4338ca", "font-size": "0.9rem", "padding": "0.4rem 0.75rem" }
};
const _hoisted_76 = { style: { "padding": "1rem 0", "text-align": "center" } };
const _hoisted_77 = ["onUpdate:modelValue"];
const _hoisted_78 = {
    key: 0,
    class: "text-[0.65rem] text-rose-500 font-bold mt-1"
};
const _hoisted_79 = { style: { "padding": "1rem", "text-align": "center" } };
const _hoisted_80 = ["onClick"];
const _hoisted_81 = { key: 0 };
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "3",
    style: { "text-align": "center", "padding": "3rem 1rem", "color": "#94a3b8", "font-style": "italic", "font-weight": "500" }
}, " Busca y selecciona repuestos para añadirlos al traslado. ", -1 /* HOISTED */));
const _hoisted_83 = [
    _hoisted_82
];
const _hoisted_84 = { class: "premium-form-footer mt-4" };
const _hoisted_85 = ["disabled"];
const _hoisted_86 = { key: 1 };
const _hoisted_87 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_88 = {
    class: "modal-window",
    style: { "max-width": "860px", "width": "95%" }
};
const _hoisted_89 = { class: "modal-header header-dark-premium" };
const _hoisted_90 = { class: "modal-title-group" };
const _hoisted_91 = {
    class: "icon-bulb-premium",
    style: { "color": "#6366f1", "border-color": "rgba(99, 102, 241, 0.2)" }
};
const _hoisted_92 = { class: "hero-text-content" };
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title-text text-white" }, "Detalles del Traslado", -1 /* HOISTED */));
const _hoisted_94 = { class: "rif-subtitle-text" };
const _hoisted_95 = {
    key: 0,
    class: "modal-body bg-light-premium p-0 m-0"
};
const _hoisted_96 = { class: "form-scroll-area" };
const _hoisted_97 = { style: { "display": "grid", "grid-template-columns": "repeat(3, 1fr)", "gap": "1rem", "margin-bottom": "1.25rem" } };
const _hoisted_98 = {
    class: "premium-form-card",
    style: { "padding": "1.25rem" }
};
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "card-badge-premium",
    style: { "margin-bottom": "1rem" }
}, "Ruta del Movimiento", -1 /* HOISTED */));
const _hoisted_100 = { style: { "display": "flex", "flex-direction": "column", "gap": "0.75rem" } };
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.7rem", "font-weight": "800", "color": "#94a3b8", "text-transform": "uppercase", "letter-spacing": "0.05em", "margin-bottom": "4px" } }, "Origen", -1 /* HOISTED */));
const _hoisted_102 = { style: { "display": "flex", "align-items": "center", "gap": "6px" } };
const _hoisted_103 = { style: { "font-weight": "700", "color": "#1e293b", "font-size": "0.9rem" } };
const _hoisted_104 = { style: { "border-top": "1px dashed #e2e8f0", "padding-top": "0.75rem" } };
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.7rem", "font-weight": "800", "color": "#94a3b8", "text-transform": "uppercase", "letter-spacing": "0.05em", "margin-bottom": "4px" } }, "Destino", -1 /* HOISTED */));
const _hoisted_106 = { style: { "display": "flex", "align-items": "center", "gap": "6px" } };
const _hoisted_107 = { style: { "font-weight": "700", "color": "#1e293b", "font-size": "0.9rem" } };
const _hoisted_108 = { style: { "border-top": "1px dashed #e2e8f0", "padding-top": "0.75rem" } };
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.7rem", "font-weight": "800", "color": "#94a3b8", "text-transform": "uppercase", "letter-spacing": "0.05em", "margin-bottom": "4px" } }, "Solicitado por", -1 /* HOISTED */));
const _hoisted_110 = { style: { "display": "flex", "align-items": "center", "gap": "6px" } };
const _hoisted_111 = { style: { "font-weight": "700", "color": "#6366f1", "font-size": "0.85rem" } };
const _hoisted_112 = {
    class: "premium-form-card",
    style: { "padding": "1.25rem" }
};
const _hoisted_113 = { style: { "display": "flex", "flex-direction": "column", "gap": "0.75rem" } };
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.7rem", "font-weight": "800", "color": "#94a3b8", "text-transform": "uppercase", "letter-spacing": "0.05em", "margin-bottom": "6px" } }, "Estado Actual", -1 /* HOISTED */));
const _hoisted_115 = { style: { "border-top": "1px dashed #e2e8f0", "padding-top": "0.75rem" } };
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.7rem", "font-weight": "800", "color": "#94a3b8", "text-transform": "uppercase", "letter-spacing": "0.05em", "margin-bottom": "4px" } }, "Fecha Traslado", -1 /* HOISTED */));
const _hoisted_117 = { style: { "font-weight": "700", "color": "#1e293b", "font-size": "0.85rem" } };
const _hoisted_118 = {
    key: 0,
    style: { "border-top": "1px dashed #e2e8f0", "padding-top": "0.75rem" }
};
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "font-size": "0.7rem", "font-weight": "800", "color": "#94a3b8", "text-transform": "uppercase", "letter-spacing": "0.05em", "margin-bottom": "4px" } }, "Completado el", -1 /* HOISTED */));
const _hoisted_120 = { style: { "font-weight": "700", "color": "#166534", "font-size": "0.85rem" } };
const _hoisted_121 = {
    class: "premium-form-card",
    style: { "padding": "1.25rem" }
};
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "card-badge-premium",
    style: { "margin-bottom": "1rem", "background": "#fff7ed", "color": "#9a3412" }
}, "Observaciones", -1 /* HOISTED */));
const _hoisted_123 = { style: { "font-size": "0.875rem", "color": "#64748b", "font-style": "italic", "line-height": "1.6", "margin": "0" } };
const _hoisted_124 = { class: "premium-form-card p-0 overflow-hidden" };
const _hoisted_125 = { style: { "padding": "1.25rem 1.5rem", "background": "#eef2ff", "border-bottom": "1px solid #e2e8f0", "display": "flex", "justify-content": "space-between", "align-items": "center" } };
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", {
    class: "card-badge-premium m-0",
    style: { "background": "white", "border": "1px solid #c7d2fe", "color": "#4f46e5" }
}, "Mercancía Trasladada", -1 /* HOISTED */));
const _hoisted_127 = { style: { "font-weight": "700", "font-size": "0.85rem", "color": "#4f46e5" } };
const _hoisted_128 = { class: "marcas-table" };
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Repuesto (SKU)"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "min-width": "130px" } }, "Unidades Enviadas"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "right" } }, "ID Detalle")
    ])
], -1 /* HOISTED */));
const _hoisted_130 = { style: { "font-weight": "700", "color": "#1e293b", "font-size": "0.95rem" } };
const _hoisted_131 = { style: { "font-size": "0.8rem", "color": "#64748b", "margin-top": "4px", "font-family": "monospace" } };
const _hoisted_132 = {
    class: "attribute-badge",
    style: { "background": "#e0e7ff", "color": "#4338ca", "font-size": "0.9rem", "padding": "0.4rem 0.75rem" }
};
const _hoisted_133 = { style: { "text-align": "right", "color": "#94a3b8", "font-size": "0.85rem", "font-weight": "600", "font-family": "monospace" } };
const _hoisted_134 = { key: 0 };
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "3",
    style: { "text-align": "center", "padding": "3rem 1rem", "color": "#94a3b8", "font-style": "italic", "font-weight": "500" }
}, " No hay productos registrados en este traslado. ", -1 /* HOISTED */));
const _hoisted_136 = [
    _hoisted_135
];
const _hoisted_137 = { class: "premium-form-footer mt-4" };
const _hoisted_138 = {
    key: 1,
    class: "p-12",
    style: { "text-align": "center", "padding": "4rem 2rem" }
};
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "margin-top": "1rem", "color": "#64748b", "font-weight": "600" } }, "Cargando información detallada...", -1 /* HOISTED */));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_SettingsIcon = _resolveComponent("SettingsIcon");
    const _component_TruckIcon = _resolveComponent("TruckIcon");
    const _component_Loader2Icon = _resolveComponent("Loader2Icon");
    const _component_EyeIcon = _resolveComponent("EyeIcon");
    const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_HashIcon = _resolveComponent("HashIcon");
    const _component_MapPinIcon = _resolveComponent("MapPinIcon");
    const _component_MapIcon = _resolveComponent("MapIcon");
    const _component_InfoIcon = _resolveComponent("InfoIcon");
    const _component_PackageIcon = _resolveComponent("PackageIcon");
    const _component_BoxIcon = _resolveComponent("BoxIcon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" TELEPORT CONTROLS AL HEADER PRINCIPAL "),
        (_openBlock(), _createBlock(_Teleport, { to: "#traslados-controls-target" }, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_SearchIcon, {
                            size: 16,
                            class: "search-icon"
                        }),
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchQuery) = $event)),
                            placeholder: "Buscar por nro, origen...",
                            class: "search-input text-sm py-2",
                            onInput: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => ($setup.handleSearch && $setup.handleSearch(...args)))
                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelText, $setup.searchQuery]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_SettingsIcon, {
                            size: 14,
                            class: "filter-icon-left"
                        }),
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.filterStatus) = $event)),
                            class: "filter-select-premium text-sm py-2",
                            onChange: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => ($setup.handleSearch && $setup.handleSearch(...args)))
                        }, _hoisted_11, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelSelect, $setup.filterStatus]
                        ])
                    ]),
                    ($setup.can($setup.P.ALMACENES.TRASLADOS_CREATE))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => ($setup.openCreateModal && $setup.openCreateModal(...args))),
                            class: "btn btn-add-premium text-sm py-2 px-3"
                        }, [
                            _createVNode(_component_TruckIcon, { size: 16 }),
                            _hoisted_12
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ])),
        _createCommentVNode(" Tabla Estilo Tienda Retail "),
        _createElementVNode("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("tbody", null, [
                    ($setup.isLoading)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                            _createElementVNode("td", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_Loader2Icon, {
                                        class: "spinner-icon text-primary",
                                        size: 32
                                    }),
                                    _hoisted_19
                                ])
                            ])
                        ]))
                        : ($setup.traslados.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_22))
                            : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.traslados, (t) => {
                        return (_openBlock(), _createElementBlock("tr", {
                            key: t.trasladoId
                        }, [
                            _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_23, " #" + _toDisplayString(t.numeroTraslado), 1 /* TEXT */)
                            ]),
                            _createElementVNode("td", null, [
                                _createElementVNode("strong", null, _toDisplayString(t.nombreAlmacenOrigen), 1 /* TEXT */)
                            ]),
                            _createElementVNode("td", null, [
                                _createElementVNode("strong", null, _toDisplayString(t.nombreAlmacenDestino), 1 /* TEXT */)
                            ]),
                            _createElementVNode("td", null, _toDisplayString($setup.formatDate(t.fechaTraslado)), 1 /* TEXT */),
                            _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(["status-badge", $setup.getStatusClass(t.estadoTraslado)])
                                }, _toDisplayString(t.estadoTraslado || 'PENDIENTE'), 3 /* TEXT, CLASS */)
                            ]),
                            _createElementVNode("td", _hoisted_24, [
                                ($setup.can($setup.P.ALMACENES.TRASLADOS_VIEW))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: ($event) => ($setup.viewTrasladoDetails(t.trasladoId)),
                                        class: "btn-icon btn-view",
                                        title: "Ver Detalles"
                                    }, [
                                        _createVNode(_component_EyeIcon, { size: 18 })
                                    ], 8 /* PROPS */, _hoisted_25))
                                    : _createCommentVNode("v-if", true),
                                ($setup.can($setup.P.ALMACENES.TRASLADOS_CREATE) && t.estadoTraslado !== 'COMPLETADO' && t.estadoTraslado !== 'CANCELADO')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        onClick: ($event) => ($setup.markAsCompleted(t.trasladoId)),
                                        class: "btn-icon btn-success-premium",
                                        title: "Marcar Completado"
                                    }, [
                                        _createVNode(_component_CheckCircleIcon, { size: 18 })
                                    ], 8 /* PROPS */, _hoisted_26))
                                    : _createCommentVNode("v-if", true),
                                ($setup.can($setup.P.ALMACENES.DELETE))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        onClick: ($event) => ($setup.confirmDelete(t.trasladoId)),
                                        class: "btn-icon btn-delete",
                                        title: "Anular Movimiento"
                                    }, [
                                        _createVNode(_component_TrashIcon, { size: 18 })
                                    ], 8 /* PROPS */, _hoisted_27))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ])
        ]),
        _createCommentVNode(" Paginación "),
        ($setup.totalPages > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                    _createTextVNode(" Mostrando página "),
                    _createElementVNode("strong", null, _toDisplayString($setup.currentPage), 1 /* TEXT */),
                    _createTextVNode(" de "),
                    _createElementVNode("strong", null, _toDisplayString($setup.totalPages), 1 /* TEXT */),
                    _createTextVNode(" (" + _toDisplayString($setup.totalCount) + " resultados) ", 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                        disabled: $setup.currentPage === 1,
                        class: "btn-ghost-premium px-3 py-1 text-sm rounded border enabled:hover:bg-slate-100 disabled:opacity-50"
                    }, "Anterior", 8 /* PROPS */, _hoisted_31),
                    _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] =
                            //@ts-ignore
                            (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                        disabled: $setup.currentPage === $setup.totalPages,
                        class: "btn-ghost-premium px-3 py-1 text-sm rounded border enabled:hover:bg-slate-100 disabled:opacity-50"
                    }, "Siguiente", 8 /* PROPS */, _hoisted_32)
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _createCommentVNode(" Modal Traslado "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                ($setup.isModalOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                        _createVNode(_component_TruckIcon, { size: 24 })
                                    ]),
                                    _hoisted_38
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[7] || (_cache[7] =
                                        //@ts-ignore
                                        (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                    class: "btn-close-dark-premium"
                                }, [
                                    _createVNode(_component_XIcon, { size: 24 })
                                ])
                            ]),
                            _createElementVNode("form", {
                                onSubmit: _cache[16] || (_cache[16] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.saveTraslado && $setup.saveTraslado(...args)), ["prevent"])),
                                class: "modal-body bg-light-premium p-0 m-0"
                            }, [
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                        _hoisted_41,
                                        _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_HashIcon, { size: 14 }),
                                                    _createTextVNode(" Número de Documento (Guía/Traslado) ")
                                                ]),
                                                _hoisted_44
                                            ]),
                                            _createElementVNode("div", _hoisted_45, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_MapPinIcon, { size: 14 }),
                                                    _createTextVNode(" Almacén de Origen ")
                                                ]),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($setup.form.almacenOrigenId) = $event)),
                                                    required: "",
                                                    onChange: _cache[9] || (_cache[9] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.validateLocations && $setup.validateLocations(...args))),
                                                    class: "premium-select"
                                                }, [
                                                    _hoisted_46,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.almacenes, (a) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: a.almacenId,
                                                            value: a.almacenId,
                                                            style: { "padding": "10px" }
                                                        }, _toDisplayString(a.nombreAlmacen) + "  —  " + _toDisplayString(a.ciudad || 'Sede Principal'), 9 /* TEXT, PROPS */, _hoisted_47));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [_vModelSelect, $setup.form.almacenOrigenId]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_48, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_MapIcon, { size: 14 }),
                                                    _createTextVNode(" Almacén de Destino ")
                                                ]),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (($setup.form.almacenDestinoId) = $event)),
                                                    required: "",
                                                    onChange: _cache[11] || (_cache[11] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.validateLocations && $setup.validateLocations(...args))),
                                                    class: "premium-select"
                                                }, [
                                                    _hoisted_49,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.almacenes, (a) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: a.almacenId,
                                                            value: a.almacenId,
                                                            disabled: a.almacenId === $setup.form.almacenOrigenId,
                                                            style: { "padding": "10px" }
                                                        }, _toDisplayString(a.nombreAlmacen) + "  —  " + _toDisplayString(a.ciudad || 'Sede Principal'), 9 /* TEXT, PROPS */, _hoisted_50));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [_vModelSelect, $setup.form.almacenDestinoId]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_InfoIcon, { size: 14 }),
                                                    _createTextVNode(" Observaciones (Opcional) ")
                                                ]),
                                                _withDirectives(_createElementVNode("textarea", {
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => (($setup.form.observaciones) = $event)),
                                                    rows: "2",
                                                    placeholder: "Motivo o detalle del traslado..."
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.observaciones]
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createCommentVNode(" SECCIÓN DE PRODUCTOS "),
                                    _createElementVNode("div", _hoisted_52, [
                                        _hoisted_53,
                                        _createCommentVNode(" Buscador de Productos "),
                                        _createElementVNode("div", _hoisted_54, [
                                            _createElementVNode("div", _hoisted_55, [
                                                _hoisted_56,
                                                _createElementVNode("div", _hoisted_57, [
                                                    _createVNode(_component_SearchIcon, {
                                                        size: 16,
                                                        style: { "position": "absolute", "left": "1rem", "color": "#94a3b8", "pointer-events": "none" }
                                                    }),
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => (($setup.productSearchTerm) = $event)),
                                                        onInput: _cache[14] || (_cache[14] =
                                                            //@ts-ignore
                                                            (...args) => ($setup.searchProducts && $setup.searchProducts(...args))),
                                                        style: { "padding-left": "2.75rem", "width": "100%", "transition": "all 0.2s" },
                                                        class: _normalizeClass(["search-input", { 'opacity-50 cursor-not-allowed bg-slate-50': !$setup.form.almacenOrigenId || !$setup.form.almacenDestinoId }]),
                                                        disabled: !$setup.form.almacenOrigenId || !$setup.form.almacenDestinoId,
                                                        placeholder: (!$setup.form.almacenOrigenId || !$setup.form.almacenDestinoId) ? 'Seleccione los almacenes primero...' : 'Escribe nombre o código del repuesto...'
                                                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_58), [
                                                        [_vModelText, $setup.productSearchTerm]
                                                    ]),
                                                    _createCommentVNode(" Resultados de búsqueda "),
                                                    ($setup.searchResults.length > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchResults, (p) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    key: p.id,
                                                                    onClick: ($event) => ($setup.addProductToList(p)),
                                                                    class: "search-item",
                                                                    style: { "padding": "12px 16px", "border-bottom": "1px solid #f1f5f9", "cursor": "pointer", "display": "flex", "align-items": "center", "gap": "12px", "transition": "background-color 0.2s" },
                                                                    onmouseover: "this.style.backgroundColor='#f8fafc'",
                                                                    onmouseout: "this.style.backgroundColor='transparent'"
                                                                }, [
                                                                    _createCommentVNode(" Icono Representativo "),
                                                                    _createElementVNode("div", _hoisted_61, [
                                                                        _createVNode(_component_PackageIcon, {
                                                                            size: 20,
                                                                            style: { "color": "#6366f1" }
                                                                        })
                                                                    ]),
                                                                    _createCommentVNode(" Información del Producto "),
                                                                    _createElementVNode("div", _hoisted_62, [
                                                                        _createElementVNode("span", _hoisted_63, _toDisplayString(p.nombre), 1 /* TEXT */),
                                                                        _createElementVNode("div", _hoisted_64, [
                                                                            _createElementVNode("span", _hoisted_65, " SKU: " + _toDisplayString(p.codigoUnico), 1 /* TEXT */)
                                                                        ])
                                                                    ]),
                                                                    _createCommentVNode(" Acciones y Stock "),
                                                                    _createElementVNode("div", _hoisted_66, [
                                                                        ($setup.form.almacenOrigenId)
                                                                            ? (_openBlock(), _createElementBlock("span", {
                                                                                key: 0,
                                                                                style: _normalizeStyle([($setup.originInventory.get(p.id) || 0) > 0
                                                                                        ? 'background: #e0e7ff; color: #4338ca; border: 1px solid #c7d2fe;'
                                                                                        : 'background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; opacity: 0.8;', { "font-size": "0.7rem", "font-weight": "800", "padding": "4px 10px", "border-radius": "999px", "display": "inline-flex", "align-items": "center" }])
                                                                            }, [
                                                                                _createVNode(_component_BoxIcon, {
                                                                                    size: 12,
                                                                                    style: { "margin-right": "4px" }
                                                                                }),
                                                                                _createTextVNode(" " + _toDisplayString(parseFloat(String($setup.originInventory.get(p.id) || 0)).toFixed(0)) + " DISP. ", 1 /* TEXT */)
                                                                            ], 4 /* STYLE */))
                                                                            : _createCommentVNode("v-if", true),
                                                                        _createElementVNode("div", _hoisted_67, [
                                                                            _createVNode(_component_PlusIcon, { size: 16 })
                                                                        ])
                                                                    ])
                                                                ], 8 /* PROPS */, _hoisted_60));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ]),
                                        _createCommentVNode(" Tabla de Productos Añadidos "),
                                        _createElementVNode("div", _hoisted_68, [
                                            _createElementVNode("table", _hoisted_69, [
                                                _hoisted_70,
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.detalles, (item, index) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: index,
                                                            style: { "background": "white" }
                                                        }, [
                                                            _createElementVNode("td", _hoisted_71, [
                                                                _createElementVNode("div", _hoisted_72, _toDisplayString(item.nombreProducto), 1 /* TEXT */),
                                                                _createElementVNode("div", _hoisted_73, _toDisplayString(item.codigoUnico), 1 /* TEXT */)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_74, [
                                                                _createElementVNode("span", _hoisted_75, [
                                                                    _createVNode(_component_BoxIcon, {
                                                                        size: 14,
                                                                        style: { "display": "inline", "margin-top": "-2px", "margin-right": "4px" }
                                                                    }),
                                                                    _createTextVNode(" " + _toDisplayString(parseFloat(String($setup.originInventory.get(item.productoId) || 0)).toFixed(0)) + " UND ", 1 /* TEXT */)
                                                                ])
                                                            ]),
                                                            _createElementVNode("td", _hoisted_76, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "number",
                                                                    "onUpdate:modelValue": ($event) => ((item.cantidad) = $event),
                                                                    min: "1",
                                                                    style: { "width": "80px", "text-align": "center", "padding": "0.5rem", "border": "2px solid #e2e8f0", "border-radius": "10px", "font-weight": "700", "color": "#0f172a", "outline": "none", "transition": "border-color 0.2s" },
                                                                    onfocus: "this.style.borderColor='#3b82f6'",
                                                                    onblur: "this.style.borderColor='#e2e8f0'"
                                                                }, null, 8 /* PROPS */, _hoisted_77), [
                                                                    [_vModelText, item.cantidad]
                                                                ]),
                                                                (item.cantidad > ($setup.originInventory.get(item.productoId) || 0))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, " ¡Excede stock! "))
                                                                    : _createCommentVNode("v-if", true)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_79, [
                                                                _createElementVNode("button", {
                                                                    type: "button",
                                                                    onClick: ($event) => ($setup.removeItem(index)),
                                                                    class: "btn-icon btn-delete",
                                                                    style: { "margin": "0 auto" },
                                                                    title: "Quitar"
                                                                }, [
                                                                    _createVNode(_component_TrashIcon, { size: 16 })
                                                                ], 8 /* PROPS */, _hoisted_80)
                                                            ])
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */)),
                                                    ($setup.form.detalles.length === 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_81, _hoisted_83))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-ghost-premium",
                                        onClick: _cache[15] || (_cache[15] =
                                            //@ts-ignore
                                            (...args) => ($setup.closeModal && $setup.closeModal(...args)))
                                    }, "Cancelar"),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn-primary-premium",
                                        style: { "background": "#10b981" },
                                        disabled: $setup.isSaving || $setup.invalidLocations
                                    }, [
                                        ($setup.isSaving)
                                            ? (_openBlock(), _createBlock(_component_Loader2Icon, {
                                                key: 0,
                                                class: "spinner-icon",
                                                size: 20
                                            }))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_86, "Confirmar Traslado"))
                                    ], 8 /* PROPS */, _hoisted_85)
                                ])
                            ], 32 /* NEED_HYDRATION */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }),
        _createCommentVNode(" Modal Ver Detalles (NEW) "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                ($setup.isDetailsModalOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                            _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, [
                                    _createElementVNode("div", _hoisted_91, [
                                        _createVNode(_component_TruckIcon, { size: 24 })
                                    ]),
                                    _createElementVNode("div", _hoisted_92, [
                                        _hoisted_93,
                                        _createElementVNode("span", _hoisted_94, "Movimiento #" + _toDisplayString($setup.selectedTraslado?.numeroTraslado), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[17] || (_cache[17] =
                                        //@ts-ignore
                                        (...args) => ($setup.closeDetailsModal && $setup.closeDetailsModal(...args))),
                                    class: "btn-close-dark-premium"
                                }, [
                                    _createVNode(_component_XIcon, { size: 24 })
                                ])
                            ]),
                            ($setup.selectedTraslado)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                    _createElementVNode("div", _hoisted_96, [
                                        _createCommentVNode(" Fila superior: 3 tarjetas "),
                                        _createElementVNode("div", _hoisted_97, [
                                            _createCommentVNode(" Ruta del traslado "),
                                            _createElementVNode("div", _hoisted_98, [
                                                _hoisted_99,
                                                _createElementVNode("div", _hoisted_100, [
                                                    _createElementVNode("div", null, [
                                                        _hoisted_101,
                                                        _createElementVNode("div", _hoisted_102, [
                                                            _createVNode(_component_MapPinIcon, {
                                                                size: 14,
                                                                style: { "color": "#f59e0b", "flex-shrink": "0" }
                                                            }),
                                                            _createElementVNode("span", _hoisted_103, _toDisplayString($setup.selectedTraslado.nombreAlmacenOrigen), 1 /* TEXT */)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_104, [
                                                        _hoisted_105,
                                                        _createElementVNode("div", _hoisted_106, [
                                                            _createVNode(_component_MapIcon, {
                                                                size: 14,
                                                                style: { "color": "#10b981", "flex-shrink": "0" }
                                                            }),
                                                            _createElementVNode("span", _hoisted_107, _toDisplayString($setup.selectedTraslado.nombreAlmacenDestino), 1 /* TEXT */)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_108, [
                                                        _hoisted_109,
                                                        _createElementVNode("div", _hoisted_110, [
                                                            _createVNode(_component_InfoIcon, {
                                                                size: 14,
                                                                style: { "color": "#6366f1", "flex-shrink": "0" }
                                                            }),
                                                            _createElementVNode("span", _hoisted_111, _toDisplayString($setup.selectedTraslado.nombreUsuarioSolicitante || 'Sistema'), 1 /* TEXT */)
                                                        ])
                                                    ])
                                                ])
                                            ]),
                                            _createCommentVNode(" Estado y fechas "),
                                            _createElementVNode("div", _hoisted_112, [
                                                _createElementVNode("div", {
                                                    class: "card-badge-premium",
                                                    style: _normalizeStyle([{ "margin-bottom": "1rem" }, $setup.selectedTraslado.estadoTraslado === 'COMPLETADO' ? 'background: #dcfce7; color: #166534;' : $setup.selectedTraslado.estadoTraslado === 'CANCELADO' ? 'background: #fee2e2; color: #991b1b;' : ''])
                                                }, " Estado y Tiempos ", 4 /* STYLE */),
                                                _createElementVNode("div", _hoisted_113, [
                                                    _createElementVNode("div", null, [
                                                        _hoisted_114,
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["status-badge", $setup.getStatusClass($setup.selectedTraslado.estadoTraslado)])
                                                        }, _toDisplayString($setup.selectedTraslado.estadoTraslado), 3 /* TEXT, CLASS */)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_115, [
                                                        _hoisted_116,
                                                        _createElementVNode("div", _hoisted_117, _toDisplayString($setup.formatDate($setup.selectedTraslado.fechaTraslado)), 1 /* TEXT */)
                                                    ]),
                                                    ($setup.selectedTraslado.fechaCompletado)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                            _hoisted_119,
                                                            _createElementVNode("div", _hoisted_120, _toDisplayString($setup.formatDate($setup.selectedTraslado.fechaCompletado)), 1 /* TEXT */)
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ]),
                                            _createCommentVNode(" Observaciones "),
                                            _createElementVNode("div", _hoisted_121, [
                                                _hoisted_122,
                                                _createElementVNode("p", _hoisted_123, _toDisplayString($setup.selectedTraslado.observaciones || 'Sin observaciones registradas para este traslado.'), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _createCommentVNode(" Tabla de mercancía "),
                                        _createElementVNode("div", _hoisted_124, [
                                            _createElementVNode("div", _hoisted_125, [
                                                _hoisted_126,
                                                _createElementVNode("span", _hoisted_127, "Total Ítems: " + _toDisplayString($setup.selectedTraslado.detalles?.length || 0), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("table", _hoisted_128, [
                                                _hoisted_129,
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedTraslado.detalles, (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: item.detalleId,
                                                            style: { "transition": "all 0.2s" }
                                                        }, [
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("div", _hoisted_130, _toDisplayString(item.nombreProducto), 1 /* TEXT */),
                                                                _createElementVNode("div", _hoisted_131, _toDisplayString(item.codigoUnico), 1 /* TEXT */)
                                                            ]),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("span", _hoisted_132, [
                                                                    _createVNode(_component_BoxIcon, {
                                                                        size: 14,
                                                                        style: { "display": "inline", "margin-top": "-2px", "margin-right": "4px" }
                                                                    }),
                                                                    _createTextVNode(" " + _toDisplayString(parseFloat(String(item.cantidad)).toFixed(0)) + " UND ", 1 /* TEXT */)
                                                                ])
                                                            ]),
                                                            _createElementVNode("td", _hoisted_133, " #" + _toDisplayString(item.detalleId), 1 /* TEXT */)
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */)),
                                                    (!$setup.selectedTraslado.detalles || $setup.selectedTraslado.detalles.length === 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_134, _hoisted_136))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_137, [
                                        _createElementVNode("button", {
                                            onClick: _cache[18] || (_cache[18] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeDetailsModal && $setup.closeDetailsModal(...args))),
                                            class: "btn-ghost-premium"
                                        }, " Cerrar Panel ")
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                    _createVNode(_component_Loader2Icon, {
                                        class: "spinner-icon",
                                        style: { "color": "#6366f1", "margin": "0 auto" },
                                        size: 48
                                    }),
                                    _hoisted_139
                                ]))
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        })
    ]));
}
